import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const moveDocumentToTrash: MutationFunction<boolean, string> = async (
  documentId,
) => {
  if (isMockServices()) return await mock(_mockType.success);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/documents/${documentId}/trash`,
    {
      method: 'PATCH',
    },
  );
  if (response.data) return response.data.success;

  throw new Error('Failed to move document to trash');
};

export default moveDocumentToTrash;

const _mockType = {
  success: true,
};
